'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import { Link } from '@/components/shared/link';
import { Loader } from '@/components/shared/loader';
import { useEnvironment } from '@/contexts/useEnvironment';
export const SsoDropdown = t0 => {
  const $ = _c(33);
  const {
    providers
  } = t0;
  const {
    clientApiBaseUrl
  } = useEnvironment();
  const [anchorEl, setAnchorEl] = useState(null);
  const [redirecting, setRedirecting] = useState(false);
  let t1;
  if ($[0] !== clientApiBaseUrl) {
    t1 = provider => `${clientApiBaseUrl}/saml/sso?provider=${encodeURIComponent(provider)}`;
    $[0] = clientApiBaseUrl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const ssoHref = t1;
  const [onlyProvider] = providers;
  if (providers.length === 1 && onlyProvider) {
    const t2 = ssoHref(onlyProvider);
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = () => setRedirecting(true);
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    let t4;
    if ($[3] !== redirecting) {
      t4 = redirecting ? <Loader size="medium" color="inherit" /> : undefined;
      $[3] = redirecting;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = {
        height: "48px"
      };
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    let t6;
    if ($[6] !== redirecting || $[7] !== t2 || $[8] !== t4) {
      t6 = <Button component={Link} prefetch={false} href={t2} fullWidth={true} variant="contained" disabled={redirecting} onClick={t3} data-testid="login-v2-sso-button" endIcon={t4} sx={t5}>Log In with SSO</Button>;
      $[6] = redirecting;
      $[7] = t2;
      $[8] = t4;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    return t6;
  }
  let t2;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = event => setAnchorEl(event.currentTarget);
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== redirecting) {
    t3 = redirecting ? <Loader size="medium" color="inherit" /> : <i className="material-symbols-arrow-drop-down-rounded" />;
    $[11] = redirecting;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      height: "48px"
    };
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== redirecting || $[15] !== t3) {
    t5 = <Button fullWidth={true} variant="contained" disabled={redirecting} data-testid="login-v2-sso-dropdown" onClick={t2} endIcon={t3} sx={t4}>Log In with SSO</Button>;
    $[14] = redirecting;
    $[15] = t3;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const t6 = Boolean(anchorEl);
  let t7;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setAnchorEl(null);
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const t8 = `${anchorEl?.offsetWidth ?? 0}px`;
  let t9;
  if ($[18] !== t8) {
    t9 = {
      paper: {
        sx: {
          minWidth: t8
        }
      }
    };
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== providers || $[21] !== ssoHref) {
    let t11;
    if ($[23] !== ssoHref) {
      t11 = provider_0 => <MenuItem key={provider_0} component={Link} prefetch={false} href={ssoHref(provider_0)} onClick={() => {
        setAnchorEl(null);
        setRedirecting(true);
      }}>{provider_0}</MenuItem>;
      $[23] = ssoHref;
      $[24] = t11;
    } else {
      t11 = $[24];
    }
    t10 = providers.map(t11);
    $[20] = providers;
    $[21] = ssoHref;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[25] !== anchorEl || $[26] !== t10 || $[27] !== t6 || $[28] !== t9) {
    t11 = <Menu anchorEl={anchorEl} open={t6} onClose={t7} slotProps={t9}>{t10}</Menu>;
    $[25] = anchorEl;
    $[26] = t10;
    $[27] = t6;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t11 || $[31] !== t5) {
    t12 = <>{t5}{t11}</>;
    $[30] = t11;
    $[31] = t5;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  return t12;
};